import { useTheme } from '@mui/material';
import { Chart as ChartJS, ChartOptions } from 'chart.js';
import { useMemo } from 'react';
import { useEstimatedCountRowsideStackBar } from '../../scanDataApi/hooks/useRowsideDistributionChart';
import { useChartFeatureMeasureLabels } from './useChartLabels';

export const useEstimatedCountRowsideStackBarChart = (
  chart?: ChartJS<'bar', number[], unknown> | null,
  plugins?: ChartOptions['plugins']
) => {
  const theme = useTheme();
  // Get the x and y axis labels for the current chart feature and dimension
  const labelResult = useChartFeatureMeasureLabels();
  const { data } = useEstimatedCountRowsideStackBar();

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },

      ...plugins,
    },
    scales: {
      y: {
        stacked: true,
        beginAtZero: true,
        min: 0,
        ticks: {
          color: theme.colors.common.white,
        },
        grid: {
          display: true,
          color: theme.colors.darkTheme.grey.muted,
        },
        title: {
          display: true,
          text: labelResult ? labelResult.yLabel : '',
          color: theme.colors.common.white,
        },
      },
      x: {
        stacked: true,
        ticks: {
          color: theme.colors.common.white,
          font: {
            size: 12,
          },
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: labelResult ? labelResult.xLabel : '',
          color: theme.colors.common.white,
        },
      },
    },
    events: ['click', 'mousemove'] as Array<keyof HTMLElementEventMap>,
  };

  const result = useMemo(
    () => ({
      data,
      options,
    }),
    [data, options]
  );

  return result;
};
